import React, {useEffect} from 'react';
import {
  Link,
} from "react-router-dom";

import {connect} from 'react-redux';
import { BanIcon, CalendarIcon, BriefcaseIcon, UserIcon, BanknotesIcon, BuildingOfficeIcon } from '@heroicons/react/20/solid'
// import {Actions as MYACTIONS} from './store/actions/myActions';
// import {Actions as TEAMACTIONS} from './store/actions/teamActions';
// import {Actions as AUTHENTICATIONACTIONS} from './store/actions/authenticationActions';
// import RegistrationForm from '../components/common/RegistrationForm'


// import mcDonaldsLogo from '../assets/images/mc-donalds.png';
// import myokaLogo from '../assets/images/myoka.png';
// import skySpiritLogo from '../assets/images/sky-spirit.png';


function MaltaFeatures({

}) {


  return (

    <div className="py-12">
      <div className="max-w-xl mx-auto px-4 sm:px-6 lg:max-w-screen-xl lg:px-8">

        <div className="relative">
          <h3 className="text-center text-3xl leading-8 font-extrabold tracking-tight text-white sm:text-4xl sm:leading-10">
           { /*<img className="h-9 sm:h-10" src={MaltaFlag} alt="Maltese Flag"/> */}
            Malta Centric
          </h3>
          <p className="mt-4 max-w-3xl mx-auto text-center text-xl leading-7 text-gray-300">
            Malta's Payroll Regulations and Reports are embedded right into the software
          </p>
        </div>

        <div className="lg:grid lg:grid-cols-3 lg:gap-8 relative mt-12 lg:mt-24 ">
          <div>
            <div className="flex items-center justify-center h-12 w-12 rounded-md bg-orange-500 text-white">
              {/* Heroicon name: globe-alt */} 
              <svg className="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9" />
              </svg>
            </div>
            <div className="mt-5">
              <h5 className="text-lg leading-6 font-medium text-white">FSS Reporting</h5>
              <p className="mt-2 text-base leading-6 text-gray-300">
                FS3, FS5, FS7 and electronic lodgement files are automatically generated by Buddy.
              </p>
            </div>
          </div>
          <div className="mt-10 lg:mt-0">
            <div className="flex items-center justify-center h-12 w-12 rounded-md bg-orange-500 text-white">
              {/* Heroicon name: scale */} 
              <svg className="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 6l3 1m0 0l-3 9a5.002 5.002 0 006.001 0M6 7l3 9M6 7l6-2m6 2l3-1m-3 1l-3 9a5.002 5.002 0 006.001 0M18 7l3 9m-3-9l-6-2m0-2v2m0 16V5m0 16H9m3 0h3" />
              </svg>
            </div>
            <div className="mt-5">
              <h5 className="text-lg leading-6 font-medium text-white">Cost of Living Adjustments</h5>
              <p className="mt-2 text-base leading-6 text-gray-300">
                Cost of Living Adjustments can be applied to all employees with a click of a button. 
              </p>
            </div>
          </div>
          <div className="mt-10 lg:mt-0">
            <div className="flex items-center justify-center h-12 w-12 rounded-md bg-orange-500 text-white">
              {/* Heroicon name: lightning-bolt */} 
              <svg className="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
              </svg>
            </div>
            <div className="mt-5">
              <h5 className="text-lg leading-6 font-medium text-white">Legal Updates Included</h5>
              <p className="mt-2 text-base leading-6 text-gray-300">
                Changes in law or tax brackets are updated by our team so you can't get them wrong.
              </p>
            </div>
          </div>
          <div className="mt-10 lg:mt-0">
            <div className="flex items-center justify-center h-12 w-12 rounded-md bg-orange-500 text-white">
              {/* Heroicon name: lightning-bolt */} 
              <BanknotesIcon className="h-6 w-6"/>
            </div>
            <div className="mt-5">
              <h5 className="text-lg leading-6 font-medium text-white">Automated Benefit Deductions</h5>
              <p className="mt-2 text-base leading-6 text-gray-300">
                Automatically deduct Sick Leave Benefits, after the third day of sick leave, as per Maltese law.
              </p>
            </div>
          </div>
          <div className="mt-10 lg:mt-0">
            <div className="flex items-center justify-center h-12 w-12 rounded-md bg-orange-500 text-white">
              {/* Heroicon name: lightning-bolt */} 
              <BuildingOfficeIcon className="h-6 w-6"/>
            </div>
            <div className="mt-5">
              <h5 className="text-lg leading-6 font-medium text-white">Industry-Based Sick Rules</h5>
              <p className="mt-2 text-base leading-6 text-gray-300">
                Sick Leave entitlements (Full & Half) are automatically calculated based on your industry's Work Regulation Orders.
              </p>
            </div>
          </div>
          <div className="mt-10 lg:mt-0">
            <div className="flex items-center justify-center h-12 w-12 rounded-md bg-orange-500 text-white">
              <CalendarIcon className="h-6 w-6"/>
            </div>
            <div className="mt-5">
              <h5 className="text-lg leading-6 font-medium text-white">Automate Public Holiday Pay</h5>
              <p className="mt-2 text-base leading-6 text-gray-300">
                Automatic Public Holiday Pay calculation for Full & Part-Time Employees
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    
  );
}

const mapStateToProps = (state) => {

  // const {
  //   myAgreements,
  // } = state.my


  return {
    // showSidebar: state.sidebar.show,
    // loggedIn: state.my.profile ? true : false,
  }
}

const mapDispatchToProps = dispatch => ({
  // myGetAgreements: () => dispatch(MYACTIONS.myGetAgreements()),
  // getProfile: () => dispatch(MYACTIONS.getProfile()),
  // isLoggedIn: () => dispatch(AUTHENTICATIONACTIONS.isLoggedIn()),
  // getDepartments: () => dispatch(TEAMACTIONS.getDepartments()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MaltaFeatures) 
